module.exports = __webpack_public_path__ + "static/media/exit-down.b0f1d94c.svg";